// @file Network requests related to attachment captions
import FetchableObject from '@@/surface/api/fetchable_object'
import { getApiFetchCommonOptions } from '@@/surface/api_fetch'
import { HTTPMethod } from '@padlet/fetch'

const API_VERSION = 1

class VideoSubtitlesApi extends FetchableObject {
  public static get url(): string {
    return `/api/${API_VERSION}/wishes/\${ wishHashid }/subtitles`
  }

  public static async download(wishHashid: string): Promise<{ blob: Blob; filename: string }> {
    const response = await fetch(this.buildUrl(this.url, { wishHashid }), {
      method: HTTPMethod.get,
    })

    if (response.status !== 200) {
      throw new Error('Subtitles failed to download')
    }

    const blob = await response.blob()
    const contentDisposition = response.headers.get('Content-Disposition')
    let filename = 'download' // default filename

    if (contentDisposition != null) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
      if (filenameMatch?.[1] != null) {
        filename = filenameMatch[1].replace(/['"]/g, '')
      }
    }

    return { blob, filename }
  }

  public static async update(wishHashid: string, subtitleFile: File): Promise<{ subtitleId?: string; status: number }> {
    const formData = new FormData()
    formData.append('wish_hashid', wishHashid)
    formData.append('subtitle_file', subtitleFile)

    const response = await fetch(this.buildUrl(this.url, { wishHashid }), {
      method: HTTPMethod.post,
      body: formData,
      ...getApiFetchCommonOptions(),
    })

    const responseJson = await response.json()
    return { subtitleId: responseJson.subtitle_id, status: response.status }
  }
}

export { VideoSubtitlesApi }
